import React from 'react';
import { StyledLessonWrapper, StyledLessonWrapperContent } from '../../Styled';
import { LessonText } from '../LessonText';
import { LessonHeading } from '../LessonHeading';
import { LessonPageHeading, LessonPageText, LessonPageWrapper, LessonPageWrapperStyles } from '../../../types/lessons';
import { CONTENT_TYPES } from '../../../constants/lessons';

interface ILessonPageWrapper extends LessonPageWrapper {
  linkColor?: string;
}

export const LessonWrapper: React.FC<ILessonPageWrapper> = props => {
  const { content, style, linkColor } = props;

  const isLearningIntentionSuccessCriteria = style?.includes(LessonPageWrapperStyles.learningIntentionSuccessCriteria);
  const isImportantTeachingPoint = style?.includes(LessonPageWrapperStyles.importantTeachingPoint);

  return (
    <StyledLessonWrapper>
      <StyledLessonWrapperContent
        isLearningIntentionSuccessCriteria={isLearningIntentionSuccessCriteria}
        isImportantTeachingPoint={isImportantTeachingPoint}
        data-testid="lesson-wrapper"
      >
        {content.map(
          (contentItem, index) =>
            (contentItem.type === CONTENT_TYPES.heading && (
              <LessonHeading
                {...(contentItem as LessonPageHeading)}
                padding={index === 0 ? '0 0 10px 0' : '30px 0 10px 0'}
                key={index}
              />
            )) ||
            (contentItem.type === CONTENT_TYPES.text && (
              <LessonText {...(contentItem as LessonPageText)} linkColor={linkColor} key={index} />
            ))
        )}
      </StyledLessonWrapperContent>
    </StyledLessonWrapper>
  );
};
